/* ============================================
   SEEK KEY — Transparent Header Controller v3
   ============================================ */

(function () {
  'use strict';

  // Activate on all pages
  var isHomepage =
    document.body.classList.contains('template-index') ||
    window.location.pathname === '/' ||
    window.location.pathname === '';

  var sectionHeader = document.querySelector('.section-header');
  if (!sectionHeader) return;

  document.body.classList.add('header-transparent');

  // On non-homepage, start in scrolled state immediately (solid bg)
  if (!isHomepage) {
    sectionHeader.classList.add('header--scrolled');
  }

  var SCROLL_THRESHOLD = window.innerWidth <= 749 ? 10 : 60;

  // Set header height as CSS variable
  var initialHeightSet = false;

  function updateHeaderHeight() {
    var h = sectionHeader.offsetHeight;
    document.documentElement.style.setProperty('--header-height-fixed', h + 'px');
    document.documentElement.style.setProperty('--header-height', h + 'px');

    // Set initial height ONCE — this prevents hero jitter on scroll
    if (!initialHeightSet) {
      document.documentElement.style.setProperty('--header-height-initial', h + 'px');
      initialHeightSet = true;
    }
  }

  // Scroll handler
  var ticking = false;

  function onScroll() {
    if (ticking) return;
    ticking = true;

    requestAnimationFrame(function () {
      // On non-homepage, always keep scrolled state
      if (!isHomepage) {
        if (!sectionHeader.classList.contains('header--scrolled')) {
          sectionHeader.classList.add('header--scrolled');
        }
        ticking = false;
        return;
      }

      var scrollY = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollY > SCROLL_THRESHOLD) {
        if (!sectionHeader.classList.contains('header--scrolled')) {
          sectionHeader.classList.add('header--scrolled');
          // Recalc height after transition (header shrinks)
          setTimeout(updateHeaderHeight, 450);
        }
      } else {
        if (sectionHeader.classList.contains('header--scrolled')) {
          sectionHeader.classList.remove('header--scrolled');
          setTimeout(updateHeaderHeight, 450);
        }
      }


      ticking = false;
    });
  }

  // Override Dawn's StickyHeader
  function overrideDawnSticky() {
    var el = document.querySelector('sticky-header');
    if (!el) return;

    if (el.onScrollHandler) {
      window.removeEventListener('scroll', el.onScrollHandler);
    }

    el.hide = function () {};
    el.reveal = function () {};
    el.reset = function () {};

    sectionHeader.classList.add('shopify-section-header-sticky');
    sectionHeader.classList.remove('shopify-section-header-hidden');
  }

  // Init
  function init() {
    updateHeaderHeight();
    overrideDawnSticky();

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateHeaderHeight, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
